import {
     GET_SYSTEM_ADMIN_PRODUCT_TYPE,
     UPDATE_SYSTEM_ADMIN_PRODUCT_TYPE,
     ADD_SYSTEM_ADMIN_PRODUCT_TYPE,
     ADD_SYSTEM_ADMIN_PRODUCT_TYPES,
     DELETE_SYSTEM_ADMIN_PRODUCT_TYPE,
} from './types';

const initialState = [];

const productTypeReducer = (state = initialState, { type, payload }) => {
     switch (type) {
          case GET_SYSTEM_ADMIN_PRODUCT_TYPE:
               return state.find((productType) => productType.id === payload);

          case UPDATE_SYSTEM_ADMIN_PRODUCT_TYPE:
               return state.map((productType) => {
                    if (productType.id === payload.id) {
                         productType = payload;
                    }
                    return productType;
               });

          case ADD_SYSTEM_ADMIN_PRODUCT_TYPE:
               return [...state, payload];

          case ADD_SYSTEM_ADMIN_PRODUCT_TYPES:
               return payload;

          case DELETE_SYSTEM_ADMIN_PRODUCT_TYPE:
               return [...state.filter((productType) => productType.id !== payload)];

          default:
               return state;
     }
};

// Fetch Product Type by id
export const getProductTypeById = (state, productTypeId) => {
     const productTypes = [...state.admin.productTypes];
     const productType = productTypes.find((pt) => pt.id === productTypeId);
     return productType || {};
};

export default productTypeReducer;
